export const customerDeletedEn = {
    companyBeDeleted: 'Company couldn´t be deleted. it has a loan active'
};

export const customerDeletedEs = {
    companyBeDeleted: 'No se pudo eliminar la empresa. tiene un préstamo activo'
};
